import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parseJson',
  standalone: true
})
export class ParseJsonPipe implements PipeTransform {

  transform(value: string, key?: string): any {
    try {
      const parsedObject = JSON.parse(value);
      return key ? parsedObject[key] : parsedObject;
    } catch (e) {
      console.error('Error parsing JSON', e);
      return null;
    }
  }

}
